import { SwapRouter } from '~/components/forms/swap/utils'
import { BridgeProviderType } from '~/types'

// Translates the frontend router name to the backend's settlement-provider
// enum. Only async-settling routers appear here; unmapped routers fall back
// to RELAY because a quote's top-level router isn't always the settler (a
// vault-router quote can embed a Relay bridge step).
//
// Lives in its own module (not utils/swap.ts) — utils/swap imports the
// useSwap component tree, and pulling that cycle into the transaction
// builders sends the dev server into an HMR invalidation loop.
const BRIDGE_PROVIDER_BY_ROUTER: Partial<
  Record<SwapRouter, BridgeProviderType>
> = {
  Relay: BridgeProviderType.RELAY,
  NearIntents: BridgeProviderType.NEAR_INTENTS,
}

export const getBridgeProviderType = (
  router: SwapRouter | undefined,
): BridgeProviderType =>
  (router && BRIDGE_PROVIDER_BY_ROUTER[router]) || BridgeProviderType.RELAY
